import { Banner } from '@repo/foundations';

interface BillingInfoBannerProps {
	/**
	 * Whether the banner should use condensed styling for card/modal contexts
	 * @default true
	 */
	inCard?: boolean;
}

export function BillingInfoBanner({ inCard = true }: BillingInfoBannerProps) {
	return (
		<Banner
			tone="info"
			message="Credits are purchased at $1.00 per credit. Credits expire 1 year after purchase."
			inCard={inCard}
		/>
	);
}
